import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import {
	AsyncHorizontalOperationsNav,
	LazyHorizontalOperationsNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { resources as alertListResources } from '@atlassian/eoc-alert-list/resources';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocTeamAlertListRoute } from '@jira/router-routes__eoc-team-alerts-routes/src/eocTeamAlertListRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import AlertList, { LazyAlertList } from './ui/spa/eoc/alert-list/index.tsx';

export const eocTeamAlertListRouteEntry: Route = createEntry(eocTeamAlertListRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: AlertList,
	layout: opsTeamLayout,

	resources: [
		...getNavigationResources(),
		...teamDashboardResources(),
		...alertListResources(),
		getConsolidationStateResource(),
	],

	navigation: {
		menuId: MenuIdPeople,
		horizontal: AsyncHorizontalOperationsNav,
	},

	forPaint: [
		LazyHorizontalOperationsNav,
		LazyAtlassianNavigation,
		LazyAlertList,
		LazyTeamDashboardSidebar,
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
